<script setup lang="ts">
import { customerServiceEmail } from '@lib/shared';

import { Locale } from '~i18n/i18nConfig';

// COMPOSABLES
const { tt, locale } = useTypedI18n();

// DATA
const LOCALE_CONTACTS: Record<
    Locale,
    {
        phones: string[];
        salesEmail: string;
        pec?: string;
    }
> = {
    [Locale.CS]: { phones: ['+420 228 887 226'], salesEmail: 'prodej@fleequid.com' },
    [Locale.DE]: { phones: ['+49 173 5130489', '+43 1 4351920'], salesEmail: 'vertrieb@fleequid.com' },
    [Locale.EN]: { phones: ['+39 0287176063'], salesEmail: 'sales@fleequid.com' },
    [Locale.ES]: { phones: ['+34 815 01 00 78'], salesEmail: 'ventas@fleequid.com' },
    [Locale.FR]: { phones: ['+39 0287176063'], salesEmail: 'ventes@fleequid.com' },
    [Locale.IT]: { phones: ['+39 0287176063'], salesEmail: 'vendite@fleequid.com', pec: 'adorea@pecaruba.it' },
    [Locale.NL]: { phones: ['+32 2 808 78 26'], salesEmail: 'verkoop@fleequid.com' },
    [Locale.PL]: { phones: ['+48 22 397 06 04'], salesEmail: 'sprzedaz@fleequid.com' },
    [Locale.PT]: { phones: ['+351 308 811 471'], salesEmail: 'vendas@fleequid.com' },
    [Locale.RO]: { phones: ['+39 0287176063'], salesEmail: 'sales@fleequid.com' },
    [Locale.RU]: { phones: ['+39 0287176063'], salesEmail: 'sales@fleequid.com' },
};

// COMPUTED
const contacts = computed(() => LOCALE_CONTACTS[locale.value] ?? LOCALE_CONTACTS[Locale.EN]);

// HELPERS
const formatPhone = (phone: string): string => phone.replace(/[^+\d]/g, '');
</script>

<template>
    <div class="flex flex-col gap-2 text-xs">
        <h4 class="font-semibold">{{ tt('footer.support') }}</h4>
        <div v-for="phone in contacts.phones" :key="phone" class="flex gap-1">
            <UIcon name="lucide:phone" class="size-4" />
            <BasePhoneLink class="text-inherit" :phone="formatPhone(phone)">{{ phone }}</BasePhoneLink>
        </div>
        <div v-if="contacts.pec" class="flex gap-1">
            <UIcon class="size-4" name="lucide:mail-check" />
            <BaseEmailLink class="text-inherit" :email="contacts.pec">{{ contacts.pec }}</BaseEmailLink>
        </div>
        <div class="flex gap-1">
            <UIcon class="size-4" name="lucide:mail" />
            <BaseEmailLink class="text-inherit" :email="contacts.salesEmail">{{ contacts.salesEmail }}</BaseEmailLink>
        </div>
        <div class="flex gap-1">
            <UIcon class="size-4" name="lucide:mail" />
            <BaseEmailLink class="text-inherit" :email="customerServiceEmail">{{ customerServiceEmail }}</BaseEmailLink>
        </div>
        <FleequidWhatsappLink />
    </div>
</template>
